/**
 * ⚠ These are used just to render the Sidebar!
 * You can include any link here, local or external.
 *
 * If you're looking to actual Router routes, go to
 * `routes/index.js`
 */
const userRoutes = [ 
  {
    path: '/app/billing',
    icon: 'MoneyStackIcon',
    name: 'Buy Credits',
  },
  {
    path: '/app/buy-me-a-coffee',
    icon: 'HeartIcon',
    name: 'Buy us a coffee',
  },
  {
    path: '/app/task-list',
    icon: 'TaskListIcon',
    name: 'Your Tasks',
  },
  {},
  {
    path: '/app/detect-humanize-ai-content',
    icon: 'AiDetectorIconCustom',
    name: 'Detect AI',
  },
  {
    path: '/app/humanize-ai',
    icon: 'AiHumanizerIconCustom',
    name: 'Humanize AI',
  },
  {
    path: '/app/plagiarism-check',
    icon: 'PlagDetectorIconCustom',
    name: 'Plagiarism Check',
  },
  {
    path: '/app/paraphrase',
    icon: 'ParaphraseIconCustom',
    name: 'Paraphraser',
  },
  {
    path: '/app/grammar',
    icon: 'GrammarIconCustom',
    name: 'Grammar Checker',
  },
  {
    path: '/app/chat',
    icon: 'AiChatIconCustom',
    name: 'All AI Chat',
    info: 'OpenAI, Grok, Claude',
  },
  {
    path: '/app/chat-with-notes',
    icon: 'PdfChatIconCustom',
    name: 'Chat with PDF',
    info: 'Upload & Chat with Files',
  },
  {
    path: '/app/dumb-it-down',
    icon: 'DumbItDownIconCustom',
    name: 'Dumb it Down',
  },
  {},
]

const adminRoutes = [ 
  {
    path: '/app/users',
    icon: 'PeopleIcon',
    name: 'Users',
  },
]

const commonRoutes = [ 
  {
    path: '/app/profile',
    icon: 'OutlinePersonIcon',
    name: 'Profile',
  },
  {
    path: '/app/achievements',
    icon: 'TrophyIcon',
    name: 'Achievements',
  },
  {
    path: '/app/api-access',
    icon: 'OutlineCogIcon',
    name: 'API Access',
  },
  {
    path: '/app/redeem-code',
    icon: 'TicketIcon',
    name: 'Redeem Code',
  },
  {
    path: '/app/logout',
    icon: 'OutlineLogoutIcon',
    name: 'Logout',
  },
  {},
]

const billingRoutes = [ 
  
  // {
  //   path: '/app/billing',
  //   icon: 'MoneyStackIcon',
  //   name: 'Buy Credits',
  // },
  // {},
  {
    path: '/app/affiliate',
    icon: 'CashIcon',
    name: 'Affiliate Program',
  },
  {
    path: '/app/earn-free-credits',
    icon: 'GiftIcon',
    name: 'Earn Free Credits',
  }
]

export const routes = {
  userRoutes,
  adminRoutes,
  commonRoutes,
  billingRoutes,
};
